import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from '@/lib/api';
import type { AppDispatch } from '@/state/store';

interface ApiError {
    message: string;
    error: unknown;
}

interface SetCourseProgressArgs {
    courseId: string;
    activityId: string;
    videoTimeSeconds?: number;
}

export const setCourseProgress = createAsyncThunk<
    api.CourseUserPosition,
    SetCourseProgressArgs,
    {
        dispatch: AppDispatch;
        rejectValue: ApiError;
    }
>('coursePlayer/setCourseProgress', async ({ activityId, courseId, videoTimeSeconds }, thunkApi) => {
    const { rejectWithValue } = thunkApi;

    try {
        return await api.setCoursePosition({
            path: { course_id: courseId },
            body: {
                activity_id: activityId,
                video_time_seconds: Math.floor(videoTimeSeconds ?? 0),
            },
        });
    } catch (e) {
        return rejectWithValue({
            message: 'Error setting course progress',
            error: e,
        });
    }
});
